
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MailboxUserInterface } from '@/services/Mailbox/interfaces';

@Component
export default class DeleteMailboxUserDialog extends Vue {
  @Prop() public user!: MailboxUserInterface;
  @Prop() public readonly onDelete!: CallableFunction;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove mailbox user ${this.user.address}?`;
  }

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async deleteMailboxUser(): Promise<void> {
    this.$emit('delete-user', this.user);
    this.destroyComponent();
  }
}
